import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from 'app/core/core.module';
import {
    AuctionItem,
    AuctionPaddleUser,
    AuctionPurchase,
    Committee,
    CommitteeMember,
    Invoice,
    InvoiceLine,
    Person,
    Proposal,
    ProposalDiscussion,
} from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PaddleDialogComponent } from '../paddle-dialog/paddle-dialog.component';
import { AuctionPurchaseDialogComponent } from '../auction-purchase-dialog/auction-purchase-dialog.component';
import { AuctionItemDialogComponent } from '../auction-item-dialog/auction-item-dialog.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-auction-overview',
    templateUrl: './auction-overview.component.html',
    styleUrls: ['./auction-overview.component.scss'],
})
export class AuctionOverviewComponent implements OnInit {
    private router = inject(Router);

    auctionPaddleInfos: any[] = [];
    auctionItems: any[] = [];
    people: Person[];
    auctionItemTypes = ['Live', 'Silent', 'Raffle Line'];

    @ViewChild('paddleDataGrid') paddleDataGrid: DxDataGridComponent;
    @ViewChild('itemDataGrid') itemDataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        const people = (await this.uow.people.all(null, 'family')) as Person[];
        this.people = _.orderBy(
            people.filter((person) => !person.deceasedDate),
            ['lastName', 'firstName'],
            ['asc', 'asc']
        );
        // this.executiveAdmin = this.auth.hasRole('Executive:Admin');
        // this.reviewOnly = !this.auth.hasRole('Executive:Clerk');
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const invoiceInfos = await this.uow.getAuctionPurchaseInvoices();
        const auctionPaddleInfos = await this.uow.getAuctionPaddles();
        auctionPaddleInfos.forEach((paddle) => {
            paddle.displayName = `Paddle ${paddle.paddleNumber} --- ${paddle.assignedTo}`;
        });
        this.auctionPaddleInfos = auctionPaddleInfos;
        this.auctionItems = await this.uow.getAuctionItems();
        this.appInfo.pleaseWaitHide();
    }

    onPaddleToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarText',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }

    paddleRowDoubleClick(e) {
        // if (!!this.reviewOnly) return;
        console.log(e);
        // return;
        this.addPaddle(e.data);
    }

    rowPrepare(e) {
        // if (e.rowType === 'data') {
        //     if (!!e.data.approved) {
        //         e.rowElement.className = e.rowElement.className + ' approved';
        //     }
        //     if (!!e.data.declined) {
        //         e.rowElement.className = e.rowElement.className + ' declined';
        //     }
        //     if (!e.data.approved && !e.data.declined) {
        //         e.rowElement.className = e.rowElement.className + ' waiting-for-vote';
        //     }
        // }
    }

    async addPaddle(selectedRow?: any) {
        let paddleUser: AuctionPaddleUser;
        if (selectedRow) {
            const paddle = await this.uow.auctionPaddles.byId(selectedRow.id);
            paddleUser = await this.uow.getAuctionPaddleUserByPaddleId(selectedRow.id);
            // const paddleUser = await this.uow.auctionPaddleUsers.byId(selectedRow.id) as AuctionPaddleUser;
        }
        const modalRef = this.modalService.show(PaddleDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                people: this.people,
                paddles: this.auctionPaddleInfos,
                paddleUser: paddleUser ? paddleUser : null,
                selectedPaddle: selectedRow ? selectedRow : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async deletePaddleUser(selectedRow: any) {
        const result = await confirm('Are you sure you want to delete this paddle user?', this.appInfo.settings.church.toUpperCase());
        if (!result) return;
        this.appInfo.pleaseWaitShow();
        const paddleUser = (await this.uow.auctionPaddleUsers.byId(selectedRow.paddleUserId)) as AuctionPaddleUser;
        console.log(paddleUser);

        if (!!paddleUser) {
            paddleUser.deleted = new Date();
            paddleUser.deletedBy = this.auth.currentUser.userName;
            await this.uow.commit();
            await this.getData();
        }
        this.appInfo.pleaseWaitHide();
    }

    async addPurchase(mode?: string) {
        let selectedRow;
        if (mode === 'item') {
            selectedRow = this.itemDataGrid.instance.getSelectedRowsData()[0];
        }
        const modalRef = this.modalService.show(AuctionPurchaseDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                auctionItems: this.auctionItems,
                auctionPaddleInfos: this.auctionPaddleInfos,
                selectedItemId: selectedRow ? selectedRow.id : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getData();
                let message = [];
                const purchase = (await this.uow.auctionPurchases.byId(result.value.id, 'auctionPaddleUser.auctionPaddle,auctionItem')) as AuctionPurchase;
                message.push('Purchase saved.\r\n');
                message.push('Paddle#: ' + purchase.auctionPaddleUser?.auctionPaddle?.paddleNumber);
                message.push('Paddle Name: ' + purchase.auctionPaddleUser.name);
                message.push('Item Name: ' + purchase.auctionItem.name);
                message.push('Amount: $' + purchase.amount);
                message.push('Total: $' + purchase.amount * purchase.quantity);
                this.appInfo.notifyToast(message.join('\r\n'), 'info', 3000, 'center bottom', 0, -50);
            }
            modalRef.hide();
        });
    }

    itemRowDoubleClick(e) {
        this.addItem(e.data);
    }

    async addItem(selectedRow?: any) {
        let auctionItem: AuctionItem;
        if (selectedRow) {
            auctionItem = (await this.uow.auctionItems.byId(selectedRow.id)) as AuctionItem;
        }
        const modalRef = this.modalService.show(AuctionItemDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                auctionItem: auctionItem ? auctionItem : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async deleteItem(selectedRow: any) {
        const result = await confirm('Are you sure you want to delete this Auction Item?', this.appInfo.settings.church.toUpperCase());
        if (!result) return;
        this.appInfo.pleaseWaitShow();
        selectedRow.deleted = new Date();
        selectedRow.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async createInvoice() {
        const selectedRow = this.paddleDataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        if (!selectedRow.paddleUserId) {
            await alert('No paddle user for selected row.', this.appInfo.settings.church.toUpperCase());
            return;
        }

        const result = await confirm('Are you sure you want to create invoices for all purchases?', this.appInfo.settings.church.toUpperCase());
        if (!result) return;
        this.appInfo.pleaseWaitShow();

        const purchases = await this.uow.getPurchasesForInvoiceByPaddleUserId(selectedRow.paddleUserId);
        if (purchases.length === 0) {
            this.appInfo.pleaseWaitHide();
            await alert('There are no purchases to invoice.', this.appInfo.settings.church.toUpperCase());
            return;
        }

        const paddleUser = (await this.uow.auctionPaddleUsers.byId(selectedRow.paddleUserId, 'person')) as AuctionPaddleUser;
        const today = moment(new Date()).startOf('day').toDate();
        const invoice = this.uow.invoices.createEntity({
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
            invoiceDate: today,
            invoiceNumber: await this.utility.getNextNumber('InvoiceNumber'),
            personId: selectedRow.personId ? selectedRow.personId : null,
            auctionPaddleUserId: selectedRow.paddleUserId ? selectedRow.paddleUserId : null,
            name: paddleUser.name,
            address: paddleUser.address,
            city: paddleUser.city,
            state: paddleUser.state,
            zip: paddleUser.zip,
            phone: paddleUser.phone,
            email: paddleUser.email,
        }) as Invoice;

        purchases.forEach((purchase, index) => {
            const line = this.uow.invoiceLines.createEntity({
                invoiceId: invoice.id,
                auctionPurchaseId: purchase.id,
                lineNumber: index + 1,
                partNumber: purchase.name,
                description: purchase.description,
                quantity: purchase.quantity,
                price: purchase.amount,
                isDonationQualified: purchase.isDonationQualified,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            }) as InvoiceLine;
            invoice.invoiceLines.push(line);
        });
        invoice.total = invoice.totalCalc;
        await this.uow.commit();

        this.router.navigate(['/invoices/' + invoice.id]);

        this.appInfo.pleaseWaitHide();
    }
}
